module.exports = __webpack_public_path__ + "cloud-2.svg?d5c56255396b13394225160dc9772327";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-2.svg
// module id = 153
// module chunks = 0